import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskListApprove = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-list-approve" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.25,
			y1: 14.261,
			x2: 16.5,
			y2: 14.261
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.25,
			y1: 18.761,
			x2: 16.5,
			y2: 18.761
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,13.886a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.25,
			y1: 9.761,
			x2: 16.5,
			y2: 9.761
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,9.386a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,18.386a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,4.511H19.5a1.5,1.5,0,0,1,1.5,1.5v15.75a1.5,1.5,0,0,1-1.5,1.5H4.5a1.5,1.5,0,0,1-1.5-1.5V6.011a1.5,1.5,0,0,1,1.5-1.5H8.25a3.75,3.75,0,0,1,7.5,0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,3.761a.375.375,0,1,1-.375.375A.375.375,0,0,1,12,3.761"
		})
	]
});
export default SvgTaskListApprove;
